export default function Configure($stateProvider) {
    $stateProvider.state('controles', {
        parent: 'gestion',
        url: '/controles',
        views: {
            gestion: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.PESEES_FACTURATIONS" | translate }}'
        }
    });

    $stateProvider.state('controles.list', {
        url: '/list',
        template: '<controles></controles>',
        rights: { domain: 'prestation', right: 'read' },
        ncyBreadcrumb: {
            label: '{{ "CONTROLES.BREADCRUMBS.CONTROLES_LIST" | translate}}'
        },
        navigation: {
            menu: 'inertes',
            translate: 'CONTROLES.BREADCRUMBS.CONTROLES_LIST',
            order: 32
        },
        search: 'CONTROLES.BREADCRUMBS.CONTROLES_LIST'
    });

    $stateProvider.state('controles.list.detail', {
        url: '/{id}',
        template: '<controle-detail></controle-detail>',
        rights: { domain: 'prestation', right: 'read' },
        ncyBreadcrumb: {
            parent: 'controles.list',
            label: '{{ "CONTROLES.BREADCRUMBS.CONTROLE_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('controles.new', {
        url: '/new',
        template: '<controle-form></controle-form>',
        rights: { domain: 'prestation', right: 'create' },
        ncyBreadcrumb: {
            parent: 'controles.list',
            label: '{{ "CONTROLES.BREADCRUMBS.CONTROLE_NEW" | translate}}'
        },
        search: 'CONTROLES.BREADCRUMBS.CONTROLE_NEW'
    });

    $stateProvider.state('controles.edit', {
        url: '/{id}/edit',
        template: '<controle-form></controle-form>',
        rights: { domain: 'prestation', right: 'update' },
        ncyBreadcrumb: {
            parent: 'controles.list',
            label: '{{ "CONTROLES.BREADCRUMBS.CONTROLE_EDIT" | translate }}'
        }
    });
}

Configure.$inject = ['$stateProvider'];
